import Skeleton from 'react-loading-skeleton';
import { ServicesCard } from "../../../Components";
import './SmartServiceCard.css'

const SmartServiceCard = ({ loading, error, service }) => {
    if (loading || error || !service) {
        return (
            <div className="Service-skeleton-card">
                <Skeleton
                    baseColor="var(--bg-footer)"
                    highlightColor="var(--bg-body)"
                    height={350}
                    style={{ borderRadius: '0px' }}
                />
            </div>
        );
    }

    return (
        <ServicesCard
            id={service.id}
            image={service.bgImg}
            text={service.txt}
            pagePath={service.pagePath}
        />
    );
};

export default SmartServiceCard;
